import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import userIcon from "../../../assets/svg/profile-user-blue.svg";
import { Link } from "react-router-dom";
import { configure_progress, gettingStartedProgress } from "../../../actions/globalAction";
import userImg from "../../../assets/user-management.png";
import { Dimmer, Loader } from "semantic-ui-react";
import { setActiveModule } from "../../../actions/sideBarActions";
class ManageUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    configureProgress = () => {
        localStorage.setItem("activeModule", "Listening");
        this.props.setModule("Listening");
        this.props.configure_progress("manage_users", this.props.total_fields);
        localStorage.setItem("activeModule", "Listening");
        this.props.setActiveModule("Listening");
    };

    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <img src={userIcon} className="icon_content" />
                            <span className="content_title">User Management</span>
                        </div>
                        <div className="text_content">
                            <p>{`Do you want your team members to also have access?`}</p>
                            <p>{`Do you want to disable access to an ex-employee?`}</p>
                            <p>{`Well, all of this can be done here.  You will need to be an administrator to get access to this section.`}</p>
                        </div>
                        <Link to="/settings/user-management">
                            <button className="gs_link" onClick={() => this.configureProgress()}>
                                {/* Manage Users */}
                                Explore
                            </button>
                        </Link>
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/b-m4v6SAqew?modestbranding=1"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>
                        {/* <img className="content-img" src={userImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        configure_progress: (field, total) => dispatch(configure_progress(field, total)),
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
        setModule: (data) => dispatch(setActiveModule(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
